import { render } from "./index.vue?vue&type=template&id=8536b4c8"
const script = {}
script.render = render

export default script